/* AYLINAS — Universal Video Showcase. One active player per section; nothing loads before it is needed. */
(function () {
  if (window.AylinasVideo) return;
  var d = document;
  d.documentElement.classList.add('ayv-js', 'ayv-ready');
  var instances = [];
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function bool(v) { return v === 'true'; }

  function Player(root) {
    var ds = root.dataset;
    this.root = root;
    this.cfg = {
      autoplay: bool(ds.autoplay), muted: bool(ds.muted), loop: bool(ds.loop), controls: bool(ds.controls),
      pause: bool(ds.pause), load: ds.load || 'facade', fs: bool(ds.fs), pip: bool(ds.pip),
      autoD: bool(ds.autoD), autoM: bool(ds.autoM)
    };
    this.items = Array.prototype.slice.call(root.querySelectorAll('template[data-ayv-src]'));
    this.stage = root.querySelector('[data-ayv-stage]');
    this.mount = root.querySelector('[data-ayv-mount]');
    this.poster = root.querySelector('[data-ayv-poster]');
    this.facade = root.querySelector('[data-ayv-play]');
    this.current = null;
    this.loaded = false;
    this.autoPaused = false;
    var f = parseInt(ds.first, 10) || 0;
    this.idx = (f >= 0 && f < this.items.length) ? f : 0;
    this.bind();
    this.observe();
    if (this.items.length) this.apply(this.idx);
  }

  Player.prototype.bind = function () {
    var self = this;
    this.onClick = function (e) {
      var t = e.target;
      if (!t || !t.closest) return;
      if (t.closest('[data-ayv-play]')) { e.preventDefault(); self.load('user'); return; }
      var pick = t.closest('[data-ayv-pick]');
      if (pick) { e.preventDefault(); self.select(parseInt(pick.getAttribute('data-ayv-pick'), 10), true); return; }
      if (t.closest('[data-ayv-prev]')) { self.step(-1); return; }
      if (t.closest('[data-ayv-next]')) { self.step(1); }
    };
    this.onChange = function (e) {
      if (e.target && e.target.matches && e.target.matches('[data-ayv-select]')) self.select(parseInt(e.target.value, 10), true);
    };
    this.root.addEventListener('click', this.onClick);
    this.root.addEventListener('change', this.onChange);
  };

  Player.prototype.observe = function () {
    var self = this, root = this.root;
    var design = window.Shopify && window.Shopify.designMode;
    if (design || reduce) root.classList.add('is-in');
    if (!('IntersectionObserver' in window)) {
      root.classList.add('is-in');
      if (this.items.length && (this.cfg.autoplay || this.cfg.load === 'direct')) this.load(this.cfg.autoplay ? 'auto' : 'idle');
      return;
    }
    this.io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) {
          root.classList.add('is-in');
          if (!self.items.length) return;
          if (!self.loaded) {
            if (self.cfg.autoplay && !design) self.load('auto');
            else if (self.cfg.load === 'direct') self.load('idle');
          } else if (self.autoPaused && self.cfg.autoplay) {
            self.autoPaused = false;
            self.play();
          }
        } else if (self.loaded && self.cfg.pause) {
          self.autoPaused = true;
          self.pause();
        }
      });
    }, { threshold: 0.35 });
    this.io.observe(this.stage || root);
  };

  Player.prototype.setRatio = function (ratio) {
    var st = this.root.style, r = parseFloat(ratio);
    var w = r ? r : 16, h = r ? 1 : 9;
    if (this.cfg.autoD) { st.setProperty('--ayv-arw', w); st.setProperty('--ayv-arh', h); }
    if (this.cfg.autoM) { st.setProperty('--ayv-arw-m', w); st.setProperty('--ayv-arh-m', h); }
  };

  Player.prototype.text = function (sel, val) {
    var el = this.root.querySelector(sel);
    if (!el) return;
    if (el.hasAttribute('data-off')) { el.hidden = true; return; }
    el.textContent = val || '';
    el.hidden = !val;
  };

  Player.prototype.apply = function (i) {
    var t = this.items[i];
    if (!t) return;
    var dd = t.dataset, root = this.root;
    if (this.poster) {
      if (dd.poster) { this.poster.src = dd.poster; this.poster.hidden = false; }
      else { this.poster.removeAttribute('src'); this.poster.hidden = true; }
    }
    if (this.facade) this.facade.setAttribute('aria-label', 'Play video' + (dd.title ? ': ' + dd.title : ''));
    if (this.cfg.autoD || this.cfg.autoM) this.setRatio(dd.ratio);
    this.text('[data-ayv-title]', dd.title);
    this.text('[data-ayv-dur]', dd.dur);
    this.text('[data-ayv-desc]', this.items.length > 1 ? dd.desc : '');
    var cta = root.querySelector('[data-ayv-cta]');
    if (cta) {
      if (dd.ctaLabel && dd.ctaUrl) { cta.textContent = dd.ctaLabel; cta.href = dd.ctaUrl; cta.hidden = false; }
      else { cta.hidden = true; }
    }
    var picks = root.querySelectorAll('[data-ayv-pick]');
    for (var k = 0; k < picks.length; k++) {
      var on = parseInt(picks[k].getAttribute('data-ayv-pick'), 10) === i;
      picks[k].classList.toggle('is-active', on);
      if (on) {
        picks[k].setAttribute('aria-current', 'true');
        var list = picks[k].closest('.ayv-pl__list');
        if (list) {
          var li = picks[k].parentNode;
          if (list.scrollWidth > list.clientWidth) list.scrollTo({ left: Math.max(0, li.offsetLeft - list.offsetLeft - 8), behavior: reduce ? 'auto' : 'smooth' });
          else if (list.scrollHeight > list.clientHeight) list.scrollTo({ top: Math.max(0, li.offsetTop - list.offsetTop - 8), behavior: reduce ? 'auto' : 'smooth' });
        }
      } else {
        picks[k].removeAttribute('aria-current');
      }
    }
    var sel = root.querySelector('[data-ayv-select]');
    if (sel) sel.value = String(i);
  };

  Player.prototype.unload = function () {
    if (this.mount) this.mount.innerHTML = '';
    if (this.stage) this.stage.classList.remove('is-playing');
    this.current = null;
    this.loaded = false;
  };

  Player.prototype.load = function (mode) {
    var t = this.items[this.idx];
    if (!t || !this.mount || !this.stage) return;
    var dd = t.dataset, kind = dd.kind, play = mode !== 'idle', self = this;
    var muted = this.cfg.muted || mode === 'auto';
    var start = parseInt(dd.start, 10) || 0, end = parseInt(dd.end, 10) || 0;
    var el;
    this.unload();
    if (kind === 'shopify') {
      var src = t.content.querySelector('video');
      if (!src) return;
      el = src.cloneNode(true);
      el.playsInline = true;
      el.setAttribute('playsinline', '');
      el.controls = this.cfg.controls;
      el.loop = this.cfg.loop && !end;
      el.muted = muted;
      if (muted) el.setAttribute('muted', '');
      el.preload = play ? 'auto' : 'metadata';
      if (!this.cfg.pip) { el.disablePictureInPicture = true; el.setAttribute('disablepictureinpicture', ''); }
      if (!this.cfg.fs) el.setAttribute('controlslist', 'nofullscreen');
      if (dd.title) el.setAttribute('aria-label', dd.title);
      if (start) el.addEventListener('loadedmetadata', function () { try { el.currentTime = start; } catch (e) {} }, { once: true });
      if (end) el.addEventListener('timeupdate', function () {
        if (el.currentTime >= end) { if (self.cfg.loop) { el.currentTime = start; } else { el.pause(); } }
      });
      if (!this.cfg.controls) {
        el.setAttribute('tabindex', '0');
        el.setAttribute('role', 'button');
        el.setAttribute('aria-label', 'Play or pause ' + (dd.title || 'video'));
        var toggle = function () { if (el.paused) { var p = el.play(); if (p && p.catch) p.catch(function () {}); } else { el.pause(); } };
        el.addEventListener('click', toggle);
        el.addEventListener('keydown', function (e) { if (e.key === ' ' || e.key === 'Enter') { e.preventDefault(); toggle(); } });
      }
      el.addEventListener('play', function () { self.announce(); });
      this.mount.appendChild(el);
      if (play) {
        var pr = el.play();
        if (pr && pr.catch) pr.catch(function () {
          if (!el.muted) { el.muted = true; var p2 = el.play(); if (p2 && p2.catch) p2.catch(function () { el.controls = true; }); }
          else { el.controls = true; }
        });
      }
    } else if (kind === 'youtube' || kind === 'vimeo') {
      el = d.createElement('iframe');
      var id = encodeURIComponent(dd.id || ''), url, q;
      if (kind === 'youtube') {
        q = ['autoplay=' + (play ? 1 : 0), 'mute=' + (muted ? 1 : 0), 'controls=' + (this.cfg.controls ? 1 : 0), 'playsinline=1', 'rel=0', 'modestbranding=1', 'enablejsapi=1', 'fs=' + (this.cfg.fs ? 1 : 0)];
        if (start) q.push('start=' + start);
        if (end) q.push('end=' + end);
        if (this.cfg.loop) q.push('loop=1', 'playlist=' + id);
        q.push('origin=' + encodeURIComponent(window.location.origin));
        url = 'https://www.youtube-nocookie.com/embed/' + id + '?' + q.join('&');
      } else {
        q = ['autoplay=' + (play ? 1 : 0), 'muted=' + (muted ? 1 : 0), 'loop=' + (this.cfg.loop ? 1 : 0), 'controls=' + (this.cfg.controls ? 1 : 0), 'playsinline=1', 'dnt=1', 'pip=' + (this.cfg.pip ? 1 : 0)];
        url = 'https://player.vimeo.com/video/' + id + '?' + q.join('&') + (start ? '#t=' + start + 's' : '');
      }
      el.src = url;
      el.title = dd.title || 'Video player';
      el.setAttribute('allow', 'accelerometer; autoplay; encrypted-media; gyroscope' + (this.cfg.pip ? '; picture-in-picture' : '') + (this.cfg.fs ? '; fullscreen' : ''));
      if (this.cfg.fs) el.setAttribute('allowfullscreen', '');
      el.setAttribute('loading', mode === 'idle' ? 'lazy' : 'eager');
      el.setAttribute('referrerpolicy', 'strict-origin-when-cross-origin');
      this.mount.appendChild(el);
    } else {
      return;
    }
    this.current = { kind: kind, el: el };
    this.loaded = true;
    this.stage.classList.add('is-playing');
    if (mode === 'user') {
      this.autoPaused = false;
      try { el.focus({ preventScroll: true }); } catch (e) {}
    }
    if (play) this.announce();
  };

  Player.prototype.cmd = function (yt, vm) {
    var c = this.current;
    if (!c) return;
    if (c.kind === 'shopify') {
      if (vm === 'play') { var p = c.el.play(); if (p && p.catch) p.catch(function () {}); }
      else { c.el.pause(); }
      return;
    }
    if (!c.el.contentWindow) return;
    var msg = c.kind === 'youtube' ? JSON.stringify({ event: 'command', func: yt, args: '' }) : JSON.stringify({ method: vm });
    try { c.el.contentWindow.postMessage(msg, '*'); } catch (e) {}
  };
  Player.prototype.pause = function () { this.cmd('pauseVideo', 'pause'); };
  Player.prototype.play = function () { this.cmd('playVideo', 'play'); };
  Player.prototype.announce = function () {
    var me = this;
    instances.forEach(function (p) { if (p !== me && p.loaded) p.pause(); });
  };

  Player.prototype.select = function (i, user) {
    if (isNaN(i) || !this.items[i]) return;
    var was = this.loaded;
    if (i === this.idx && was) return;
    this.unload();
    this.idx = i;
    this.apply(i);
    if (user || was) this.load('user');
    else if (this.cfg.load === 'direct') this.load('idle');
  };

  Player.prototype.step = function (dir) {
    var n = this.items.length;
    if (n < 2) return;
    this.select((this.idx + dir + n) % n, this.loaded);
  };

  Player.prototype.destroy = function () {
    if (this.io) this.io.disconnect();
    this.root.removeEventListener('click', this.onClick);
    this.root.removeEventListener('change', this.onChange);
    this.unload();
    var me = this;
    instances = instances.filter(function (p) { return p !== me; });
  };

  function init(scope) {
    var roots = (scope || d).querySelectorAll('[data-ayv]');
    for (var i = 0; i < roots.length; i++) {
      if (roots[i].__ayv) continue;
      roots[i].__ayv = new Player(roots[i]);
      instances.push(roots[i].__ayv);
    }
  }

  d.addEventListener('shopify:section:load', function (e) { init(e.target); });
  d.addEventListener('shopify:section:unload', function (e) {
    var roots = e.target.querySelectorAll('[data-ayv]');
    for (var i = 0; i < roots.length; i++) { if (roots[i].__ayv) { roots[i].__ayv.destroy(); roots[i].__ayv = null; } }
  });
  d.addEventListener('shopify:block:select', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var root = t.closest('[data-ayv]');
    if (!root || !root.__ayv) return;
    var pick = t.querySelector('[data-ayv-pick]');
    if (pick) root.__ayv.select(parseInt(pick.getAttribute('data-ayv-pick'), 10), false);
  });
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  window.AylinasVideo = { init: init };
})();
